module.exports = __webpack_public_path__ + "static/media/IndianSunset.37016656.jpg";